// Core Rulebook Communication and Scrolls.
const communicationScrolls = [
  { name: 'Case, Map or Scroll', category: 'Communication & Scrolls', cost: '1 gp', weight: '1/2 lb.', description: 'Holds up to ten rolled sheets of paper or five rolled sheets of parchment.' },
  { name: 'Ink (1 oz. Vial)', category: 'Communication & Scrolls', cost: '8 gp', weight: '—', description: 'Ink in colors other than black costs twice as much.' },
  { name: 'Paper (Sheet)', category: 'Communication & Scrolls', cost: '4 sp', weight: '—', description: '' },
  { name: 'Parchment (Sheet)', category: 'Communication & Scrolls', cost: '2 sp', weight: '—', description: '' },
  { name: 'Sealing Wax', category: 'Communication & Scrolls', cost: '1 gp', weight: '1 lb.', description: '' },
  { name: 'Signal Whistle', category: 'Communication & Scrolls', cost: '8 sp', weight: '—', description: '' },
  { name: 'Signet Ring', category: 'Communication & Scrolls', cost: '5 gp', weight: '—', description: '' },
];

export default communicationScrolls;
